<template>
  <div>
    <wc-data-box
      title='Module Access'
      titleIcon='mdi-apps'
      titleIconColor='info'
    >
      <v-card-text>
        <div class='mt-4 mb-2'>
          Below are all available modules. Simply flip the toggle swith to change this user's access to a given module.
          When the toggle is on the right and colored, the user will have access to that module. Only modules for which
          the user has access will appear on their dashboard.
        </div>
      </v-card-text>
      <v-simple-table dense>
        <template v-slot:default>
          <thead>
            <tr>
              <th width='150' class='text-xs-left'>Module</th>
              <th></th>
              <th width=50>Access</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for='a in appMatrix' :key='a.appid'>
              <td>{{ a.app.app_name }}</td>
              <td class='text-xs-left'>
                <span class='grey--text'>{{ a.status }}</span>
              </td>
              <td class='text-xs-right'>
                <v-switch dense hide-details v-model='a.hasAccess' color='green' @click='changeAppAccess(a, a.hasAccess)'></v-switch>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
      <v-card-text>
      <div class='mt-4 grey--text'>
        <v-icon color='grey lighten-2'>mdi-information-outline</v-icon>
        Changes are initiated immediately upon flipping a toggle. No need to click a "save" button.<br>
        (Releases has been temporarily removed from the module menu)
      </div>
      </v-card-text>

    </wc-data-box>

  </div>
</template>

<script>
import settingsAPI from '@/modules/settings/api/settings'
import staffingAPI from '../../api/staffing'
import miscServices from '@/services/misc'
import _ from 'lodash'

export default {
  name: 'app-access',
  props: {
    profile: {
      required: true
    }
  },
  data: () => ({
    isLoading: true,
    apps: [],
    appMatrix: [],
    allowedApps: []
  }),
  mounted () {
    this.getData()
  },
  methods: {
    async getData () {
      this.isLoading = true
      // Get all the apps
      this.apps = _.orderBy(await settingsAPI.getApps(), 'dashboard_order')
      // Get the apps this user has access to
      this.allowedApps = await staffingAPI.getAppAccess(this.profile.user)

      // Build matrix of this relationship

      for (let i = 0; i < this.apps.length; i++) {
        let tmp = {
          appid: this.apps[i].id,
          app: this.apps[i],
          saving: false,
          status: '',
          hasAccess: false
        }
        if (this.allowedApps.find(a => a.app === this.apps[i].id)) {
          tmp.hasAccess = true
        } else {
          tmp.hasAccess = false
        }
        this.appMatrix.push(tmp)
      }
      this.isLoading = false
    },
    async changeAppAccess (app, hasAccess) {
      // First task is to set this app status to "working on it..."
      let index = _.indexOf(this.appMatrix, app)
      // let hasAccess = this.allowedApps.find(a => a.id === app.appid)
      if (!hasAccess) {
        // At this point, the user already has access, so we need to remove it
        this.appMatrix[index].status = 'Removing access...'
        // Now that we know which app to remove, we simply delete it from the API
        let removeThisApp = this.allowedApps.find(a => a.app === this.appMatrix[index].appid)
        await staffingAPI.removeAppAccess(removeThisApp.id)

        // Now that it's deleted from the API, also need to delete it from the local array
        this.allowedApps = miscServices.removeObject(this.allowedApps, removeThisApp)
        this.appMatrix[index].status = 'Access removed'
      } else {
        // But, if the user does not already have access to this app, we add it
        this.appMatrix[index].status = 'Adding access...'
        let appAccessObject = {
          user: this.profile.user,
          app: app.appid
        }

        let newAccess = await staffingAPI.addAppAccess(appAccessObject)
        this.allowedApps.push(newAccess)
        this.appMatrix[index].status = 'Access added'
      }
    }
  }
}
</script>
